import MyProfileController from "./myProfileController";

import './myProfile.scss';

const MyProfileComponent = {
    template: require('./myProfileView.html'),
    controller: MyProfileController,
};

export default MyProfileComponent;



// WEBPACK FOOTER //
// ./src/app/pages/user/myProfile/myProfileComponent.js